export default "__VITE_ASSET__BoyCSEDq__"